import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

export const ThemeToggle = () => {
    const [theme, setTheme] = useState("dark");

    useEffect(() => {
        const stored = localStorage.getItem("vichu-theme") || "dark";
        applyTheme(stored);
        setTheme(stored);
    }, []);

    const applyTheme = (next) => {
        const root = document.documentElement;
        root.classList.remove("light", "dark");
        root.classList.add(next);
    };

    const toggle = () => {
        const next = theme === "dark" ? "light" : "dark";
        setTheme(next);
        applyTheme(next);
        localStorage.setItem("vichu-theme", next);
    };

    return (
        <button
            type="button"
            onClick={toggle}
            data-testid="theme-toggle-btn"
            aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
            className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-[var(--ink-border)] bg-[var(--ink-surface)] text-[var(--ink-text-secondary)] transition-colors hover:border-ink-cyan/40 hover:text-ink-cyan"
        >
            {theme === "dark" ? (
                <Sun className="h-4 w-4" />
            ) : (
                <Moon className="h-4 w-4" />
            )}
        </button>
    );
};

export default ThemeToggle;
